// Local-timezone helpers for leaderboard windows & NPB tier detection.
// Values are ISO-8601 strings that include the browser's UTC offset,
// so the backend can compare against UTC-stored `created_at` values
// without ambiguity.

/** Start of the local calendar week (Monday 00:00). */
export const localStartOfWeek = () => {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  const dow = d.getDay();                     // 0=Sun … 6=Sat
  const back = dow === 0 ? 6 : dow - 1;       // days since Monday
  d.setDate(d.getDate() - back);
  return d.toISOString();
};

/** Start of last week (Monday 00:00 of the previous local calendar week). */
export const localStartOfLastWeek = () => {
  const d = new Date(localStartOfWeek());
  d.setDate(d.getDate() - 7);
  return d.toISOString();
};

/** Start of the local calendar month (day 1 at 00:00). */
export const localStartOfMonth = () => {
  const d = new Date();
  d.setDate(1);
  d.setHours(0, 0, 0, 0);
  return d.toISOString();
};
